import React from 'react';
import { SETTINGS } from 'refactored/features/emergencies/constants';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import InnerColumn from 'refactored/features/emergencies/ui/columns/inner-column';
import Row from 'refactored/features/emergencies/ui/rows/row';
import BlackText from 'refactored/features/emergencies/ui/texts/black-text';
import RegularText from 'refactored/features/emergencies/ui/texts/regular-text';
import {
  getFormatedDate,
  getFormatedTime,
} from 'refactored/features/emergencies/utils/date-utils';

import styled from 'styled-components';

const CustomBlackText = styled(BlackText)`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CustomRegularText = styled(RegularText)`
  font-weight: 700;
`;

export const LocationsColumn = ({ ticket }) => {
  const pickupCityUppercase = ticket.order_data.pickup.city.toUpperCase();
  const dropoffCityUppercase = ticket.order_data.dropoff.city.toUpperCase();

  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.LOCATIONS}
    >
      <Row>
        <InnerColumn width={'50%'}>
          <CustomBlackText>{pickupCityUppercase}</CustomBlackText>
          <CustomRegularText>
            {ticket.order_data.pickup.country} -{' '}
            {ticket.order_data.pickup.zipcode}
          </CustomRegularText>
          <RegularText>
            {getFormatedDate(ticket.order_data.pickup.date)}{' '}
            {getFormatedTime(ticket.order_data.pickup.time_from)} -{' '}
            {getFormatedTime(ticket.order_data.pickup.time_to)}
          </RegularText>
        </InnerColumn>
        <InnerColumn width={'50%'}>
          <CustomBlackText>{dropoffCityUppercase}</CustomBlackText>
          <CustomRegularText>
            {ticket.order_data.dropoff.country} -{' '}
            {ticket.order_data.dropoff.zipcode}
          </CustomRegularText>
          <RegularText>
            {getFormatedDate(ticket.order_data.dropoff.date)}{' '}
            {getFormatedTime(ticket.order_data.dropoff.time_from)} -{' '}
            {getFormatedTime(ticket.order_data.dropoff.time_to)}
          </RegularText>
        </InnerColumn>
      </Row>
    </BodyColumn>
  );
};
